import * as React from 'react'

import { cn } from '@/utils/shadcn/utils'

type InputVariant = 'default' | 'tableSearch'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: InputVariant
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = 'default', ...props }, ref) => {
    return (
      <input
        data-hotkeys-disabled
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-[color:var(--color-border)] bg-[color:var(--color-layer-3)] px-3 py-1 text-sm text-[color:var(--color-text-2)] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[color:var(--color-text-0)] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[color:var(--color-accent)] disabled:cursor-not-allowed disabled:opacity-50',
          variant === 'tableSearch' &&
            'dark:bg-transparent dark:border-[#17263c] dark:text-white-dark dark:placeholder:text-slate-400',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
